import { UAParser } from 'ua-parser-js'

/**
 * https://www.npmjs.com/package/ua-parser-js
 * Possible 'os.name'
 * AIX, Amiga OS, Android, Arch, Bada, BeOS, BlackBerry, CentOS, Chromium OS, Contiki,
 * Fedora, Firefox OS, FreeBSD, Debian, DragonFly, Gentoo, GNU, Haiku, Hurd, iOS,
 * Joli, Linpus, Linux, Mac OS, Mageia, Mandriva, MeeGo, Minix, Mint, Morph OS, NetBSD,
 * Nintendo, OpenBSD, OpenVMS, OS/2, Palm, PCLinuxOS, Plan9, Playstation, QNX, RedHat,
 * RIM Tablet OS, RISC OS, Sailfish, Series40, Slackware, Solaris, SUSE, Symbian, Tizen,
 * Ubuntu, UNIX, VectorLinux, WebOS, Windows [Phone/Mobile], Zenwalk
 */
const MOBILE_OS_LIST = [
  'Android',
  'iOS',
  'BlackBerry',
  'Windows Mobile',
  'Windows Phone',
  'Windows [Phone/Mobile]',
  'Bada',
  'Symbian',
  'Palm',
  'WebOS',
  'Sailfish',
  'Firefox OS',
  'MeeGo',
  'Tizen',
  'RIM Tablet OS',
]

const AOS_LIST = ['Android[-x86]', 'Android']
const IOS_LIST = ['iOS']

export default class PlatformService {
  readonly isIOS: boolean = false
  readonly isAOS: boolean = false
  readonly isDesktop: boolean = false
  readonly isMobile: boolean = false
  readonly platform: string = ''
  readonly osName: string = ''

  constructor(headers: Readonly<Record<string, string | undefined>>) {
    const uaHeader = headers['user-agent']
    const userAgent = UAParser(uaHeader)

    this.osName = userAgent.os.name ?? ''
    this.isDesktop = !MOBILE_OS_LIST.includes(this.osName)
    this.isMobile = !this.isDesktop
    this.isIOS = IOS_LIST.includes(this.osName)
    this.isAOS = AOS_LIST.includes(this.osName)
  }
}
